<template>
  <div class="page-tabs-index">
    <el-tabs v-model="activeRoute" for-test="activeRoute" type="card" :closable="closable" @tab-click="clickTab" @edit="handleTabsEdit">
      <el-tab-pane
        :key="item.route"
        v-for="(item, index) in tabs"
        :label="item.title"
        :name="item.route"
      >
        <span slot="label" @click.middle="removeTabByMiddle(item.route)">{{item.title}}</span>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<style scoped lang="scss">
// 组件高度
$tabLineHeight:30px;
// 边框颜色
$borderColor: #488ba0;
// 未激活的以及tab本身的背景
$background: #00224a;
// 激活的标签的背景
$background-active: #09142e;
// 未激活标签的字体颜色
$fontColor:#30c0cd;
.page-tabs-index{
  height: $tabLineHeight;
  /deep/ .el-tabs{
  }
  // 底部横线
  /deep/ .el-tabs__header{
    height: $tabLineHeight;
    background: $background;
    box-sizing: border-box;
    border-bottom: 1px solid $borderColor;
  }
  // 左右滚动按钮
  /deep/ .el-tabs__nav-prev {
    height: $tabLineHeight;
    line-height: $tabLineHeight;
  }
  /deep/ .el-tabs__nav-next {
    height: $tabLineHeight;
    line-height: $tabLineHeight;
  }
  /deep/ .el-tabs__nav{
    border-radius: 0;
    border-left: none;
    border-right: none;
    border-top: none ;
  }

  /deep/ .el-tabs__item{
    height: $tabLineHeight;
    line-height: $tabLineHeight;
    border-color: $borderColor;
    color: #fff;
    border-right: 1px solid $borderColor;
    //border-radius: 3px 3px 0 0;
  }

  // 左侧第一个
  /deep/ .el-tabs__item.is-active:first-child{
    border-left: none;
  }

  /deep/ .el-tabs__item:not(.is-disabled){
    color: $fontColor;
    border-left: none;
    border-top: 2px solid transparent;
  }

  /deep/ .el-tabs__item.is-active{
    border-bottom: 1px solid $background-active;
    border-top: 2px solid $borderColor;
    border-right: 1px solid $borderColor;
    background: $background-active;
    color: #fff;
  }
}
</style>

<!--☯js-->
<script>
  import * as eventJs from '../../../../../../src/business-components/page-tabs/event.js'
  const {event, life, watch} = eventJs.default ? eventJs.default : eventJs
  import * as modelJS from '../../../../../../src/business-components/page-tabs/model.js'
  const model = modelJS.default ? modelJS.default : modelJS
  import * as methodsJs from '../../../../../../src/business-components/page-tabs/methods.js'
  const methodsSource = methodsJs.default ? methodsJs.default : methodsJs
  import vmConfig from '../../../../core/vmConfigHandler.js'
  // 异步加载某些情况下会出问题，原因未知，所以暂时不采用异步加载
  // r => require.ensure([], () => r(require('%path')), 'c-business-page-tabs')
  export default {
    name: 'business-page-tabs', // o not use built-in or reserved HTML elements as component id:img, 意思是不能和html标签同名，那么加个下划线好了
    components: {
      /*import components file template:'business-page-tabs': require('%path').default,
       */
      /*start:import components file*/
'base-account-info': require('./../../base-components/account-info/index.vue').default,
       'base-back': require('./../../base-components/back/index.vue').default,
       'base-blackHandle': require('./../../base-components/blackHandle/index.vue').default,
       'base-bottomFloat': require('./../../base-components/bottomFloat/index.vue').default,
       'base-card-header': require('./../../base-components/card-header/index.vue').default,
       'base-carDriverInfo': require('./../../base-components/carDriverInfo/index.vue').default,
       'base-cascader-select-on-click': require('./../../base-components/cascader-select-on-click/index.vue').default,
       'base-check-all': require('./../../base-components/check-all/index.vue').default,
       'base-cropper': require('./../../base-components/cropper/index.vue').default,
       'base-datetimerange': require('./../../base-components/datetimerange/index.vue').default,
       'base-dialog': require('./../../base-components/dialog/index.vue').default,
       'base-empty': require('./../../base-components/empty/index.vue').default,
       'base-export': require('./../../base-components/export/index.vue').default,
       'base-filter': require('./../../base-components/filter/index.vue').default,
       'base-image-carousel': require('./../../base-components/image-carousel/index.vue').default,
       'base-img-base': require('./../../base-components/img-base/index.vue').default,
       'base-img-viewer': require('./../../base-components/img-viewer/index.vue').default,
       'base-key-value': require('./../../base-components/key-value/index.vue').default,
       'base-my-column': require('./../../base-components/my-column/index.vue').default,
       'base-number-input': require('./../../base-components/number-input/index.vue').default,
       'base-plate': require('./../../base-components/plate/index.vue').default,
       'base-quarter-datepicker': require('./../../base-components/quarter-datepicker/index.vue').default,
       'base-simple-menu': require('./../../base-components/simple-menu/index.vue').default,
       'base-yearrange': require('./../../base-components/yearrange/index.vue').default,
       /*end:import components file*/
    },
    ...vmConfig(model, life, event, watch, methodsSource)
  }
</script>